module.exports = __webpack_public_path__ + "img/jpg.36dcc70f.svg";